import React, { useState, useEffect } from 'react';
import s from './style.css';
const Modal = ({ visible, setVisible, cancel = () => { }, children }) => {
    const [opacity, setOpacity] = useState(0);
    useEffect(() => {
        if (visible && opacity === 0) {
            setTimeout(() => setOpacity(1), 0);
        }
        else if (!visible && opacity === 1) {
            setOpacity(0);
        }
    }, [visible, opacity]);
    if (!visible)
        return null;
    return (React.createElement("div", { className: s.container, style: { opacity }, onClick: () => {
            cancel();
            setVisible(false);
        }, onKeyDown: (e) => {
            if (e.key === 'Escape') {
                cancel();
                setVisible(false);
            }
        }, role: 'button', tabIndex: 0 },
        React.createElement("div", { onClick: (e) => e.stopPropagation(), onKeyDown: (e) => e.stopPropagation(), role: 'button', tabIndex: 0, className: s.innerContainer }, children)));
};
export default Modal;
